import React from "react"
import {useTheme} from "@/hooks/useTheme"

const StickyButtonContainer = ({
                                 buttons = [],
                                 style = {}
                               }) => {
  const theme = useTheme()

  const containerStyle = {
    ...theme.stickyButtonContainer.container,
    ...style
  }

  // Calculate spacer height based on number of buttons
  const getSpacerHeight = () => {
    // Base height: container padding (top/bottom) + button heights + gaps between buttons + extra spacing
    const baseHeight = 80 // container padding + extra spacing
    const buttonHeight = 55 // approximate button height
    const gapHeight = 16 // gap between buttons
    const extraSpacing = 20 // additional breathing room
    return baseHeight + (buttons.length * buttonHeight) + ((buttons.length - 1) * gapHeight) + extraSpacing
  }

  const spacerStyle = {
    height: `${getSpacerHeight()}px`,
    width: '100%'
  }

  return (
    <>
      {/* Spacer to prevent content overlap */}
      <div style={spacerStyle}/>

      {/* Fixed positioned button container */}
      <div style={containerStyle}>
        {buttons.map((button, index) => {
          const getButtonStyle = () => {
            if (button.disabled) return theme.stickyButtonContainer.buttonDisabled
            if (button.secondary) return theme.stickyButtonContainer.buttonSecondary
            return theme.stickyButtonContainer.buttonPrimary
          }

          const buttonStyle = {
            ...theme.stickyButtonContainer.button,
            ...getButtonStyle(),
            width: button.fullWidth !== false ? '100%' : 'auto',
            ...button.style
          }

          return (
            <button
              key={index}
              onClick={button.onClick}
              disabled={button.disabled || false}
              style={buttonStyle}
              {...button.props}
            >
              {button.text || button.children}
            </button>
          )
        })}
      </div>
    </>
  )
}

export default StickyButtonContainer